/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import BannersFetcher from '../../common/BannersFetcher';
import { getConfiguration } from '../../data/utils/configuration';
import EventsByDateSingleSport from './EventsByDateSingleSport';

function MultiEventsByDate(props) {
    const conf = getConfiguration();
    const filter = props.filter;

    const [state, setState] = useState({
        filter: filter,
        sportList: filter.sport ? [filter.sport] : [],
        singleSportMode: false,
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        addSport(sport) {
            this.update({sportList: this.sportList.concat(sport)});
        },
        openSingleSport(sport) {
            this.update({sportList: [sport], singleSportMode: true});
        },
        changeFilter(filter) {
            this.update({filter, sportList: [filter.sport], singleSportMode: false});
        },
        openAllSports() {
            this.update({sportList: [this.filter.sport], singleSportMode: false});
        }
    });

    function addSport(sport) {
        state.addSport(sport);
    }

    function openSingleSport(sport) {
        state.openSingleSport(sport);
    }

    function openAllSports() {
        state.openAllSports();
    }

    useEffect(() => {
        if (filter.date !== state.filter.date || filter.type !== state.filter.type) {
            state.changeFilter(filter);
        }
    }, [filter.date, filter.type]);

    return (
        <>
            {!conf.mbep &&
                <BannersFetcher />
            }
            {state.sportList.map((s, i) => {
                const key = `${state.filter.date}-${state.filter.type}-${s.id}`;
                return (
                    <EventsByDateSingleSport key={key}
                                                data={props.data}
                                                sport={s}
                                                showSportsMenu={i === 0}
                                                loadNextSport={!state.singleSportMode}
                                                selectedSport={state.singleSportMode ? state.sportList[0] : null}
                                                filter={filter}
                                                addSport={addSport}
                                                openSingleSport={openSingleSport}
                                                openAllSports={openAllSports} />
                );
            })}
        </>
    );
}

const MultiEventsByDateMemo = React.memo(MultiEventsByDate, (prevProps, nextProps) => {
    if (prevProps.filter === nextProps.filter) {
      return true;
    }
    return false;
});

export default MultiEventsByDateMemo;